import PropTypes from 'prop-types'
import React from 'react'
import TextSeason from 'components/TextSeason'
import TextEpisode from 'components/TextEpisode'
import { useSelector } from 'react-redux'
import { selectStaticTextByKey } from 'services/static-text/selectors'

function getClassName (inputClassName) {
  return ['text-season-episode'].concat(inputClassName || []).join(' ')
}

function TextSeasonEpisode ({
  className,
  lang,
  season,
  episode,
  isGuide,
}) {
  const staticText = useSelector(selectStaticTextByKey('videoPlayerMeta'))

  if (isGuide && episode) {
    return (
      <span className={getClassName(className)}>
        {staticText.get('lesson')}&nbsp;{episode}
      </span>
    )
  }

  if (!season && !episode) {
    return null
  }
  return (
    <span className={getClassName(className)}>
      {season ? <TextSeason lang={lang} number={season} /> : null}
      {season && episode ? (
        <span className="text-season-episode__separator">:</span>
      ) : null}
      {episode ? (
        <TextEpisode lang={lang} number={episode} />
      ) : null}
    </span>
  )
}

TextSeasonEpisode.propTypes = {
  episode: PropTypes.number,
  season: PropTypes.number,
  className: PropTypes.array,
  lang: PropTypes.string,
  isGuide: PropTypes.bool,
}

export default React.memo(TextSeasonEpisode)
